/* EPOCH card — Add-to-cart AJAX handler.
   - Intercepts clicks/keyboard on [data-cart-add] elements inside .ephoc-card.
   - Stops propagation so the parent <a class="ephoc-card"> link doesn't navigate.
   - Uses Shopify's Section Rendering API to refresh the cart UI live.
   - Hands the parsed state to <cart-drawer>.renderContents() so the drawer opens.
   - Animates the cart icon + count bubble on success. */
(function () {
  if (window.__ephocCartHandlerInstalled) return;
  window.__ephocCartHandlerInstalled = true;

  function getSectionInnerHTML(html, selector) {
    try {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    } catch (e) { return null; }
  }

  function bounceCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('ephoc-cart-bounce');
    void icon.offsetWidth;
    icon.classList.add('ephoc-cart-bounce');
    setTimeout(function () { icon.classList.remove('ephoc-cart-bounce'); }, 900);

    var bubble = icon.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.classList.remove('ephoc-count-flash');
      void bubble.offsetWidth;
      bubble.classList.add('ephoc-count-flash');
      setTimeout(function () { bubble.classList.remove('ephoc-count-flash'); }, 600);
    }
  }

  async function addToCart(btn) {
    if (btn.dataset.busy === '1') return;
    var id = btn.dataset.variantId;
    if (!id) {
      console.warn('[EPOCH] cart-add: no variant id');
      btn.textContent = 'Unavailable';
      setTimeout(function () { btn.textContent = btn.dataset.label || 'Add to cart'; }, 1600);
      return;
    }
    btn.dataset.busy = '1';
    btn.dataset.label = btn.dataset.label || btn.textContent;
    btn.textContent = 'Adding…';

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToFetch = ['cart-icon-bubble'];
    if (cartDrawer) sectionsToFetch.push('cart-drawer');

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: id,
          quantity: 1,
          sections: sectionsToFetch.join(','),
          sections_url: window.location.pathname
        })
      });
      var data = await res.json().catch(function () { return null; });
      if (!res.ok) {
        var msg = (data && data.description) || 'Error';
        console.error('[EPOCH] cart-add failed:', res.status, data);
        btn.textContent = msg.length > 18 ? 'Error' : msg;
        setTimeout(function () {
          btn.textContent = btn.dataset.label;
          btn.dataset.busy = '';
        }, 2400);
        return;
      }

      if (data && data.sections) {
        if (data.sections['cart-icon-bubble']) {
          var iconHost = document.getElementById('cart-icon-bubble');
          var iconInnerHTML = getSectionInnerHTML(data.sections['cart-icon-bubble'], '.shopify-section')
                            || data.sections['cart-icon-bubble'];
          if (iconHost && iconInnerHTML) iconHost.innerHTML = iconInnerHTML;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          try { cartDrawer.renderContents(data); }
          catch (e) { console.warn('[EPOCH] cart-drawer.renderContents failed:', e); }
        }
      }

      bounceCartIcon();

      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';

      try {
        var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (_) {}

      setTimeout(function () {
        btn.textContent = btn.dataset.label;
        btn.classList.remove('is-added');
        btn.dataset.busy = '';
      }, 1800);
    } catch (err) {
      console.error('[EPOCH] cart-add network error:', err);
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.textContent = btn.dataset.label || 'Add to cart';
        btn.dataset.busy = '';
      }, 2400);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-cart-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  }, true);
})();
